module.exports = __webpack_public_path__ + "img/add.84b8bafe.svg";